module.exports = require('./toPairs');



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/entries.js
// module id = 203
// module chunks = 0